







































































































































import Vue from "vue";
import Component from "vue-class-component";
import fieldData from "@/ts/FormData";
import func from "@/ts/FormFunctions";
import api from "@/ts/functions";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { IPermitVueModel } from '@/ts/models/IPermitVueModel';
import AddressInfo from "@/views/shared/AddressInfo.vue";
import ContactInfo from "@/views/shared/ContactInfo.vue";
import { IContactVueModel } from "@/ts/models/IContactVueModel";
import VueSimpleSuggest from 'vue-simple-suggest/dist/cjs';
import cloneDeep from 'lodash/fp/cloneDeep';

@Component({
    props: {
        form: {
            type: Object as () => IPermitVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        },
        isRenewal: {
            type: Boolean
        }
    },
    components: {
        AddressInfo, ContactInfo, VueSimpleSuggest
    }
})
export default class SiteInfoRenewal extends Vue {
    name: string = "SiteInfoRenewal";
    title: string = "";
    index: number = NaN;
    errorMsgs = ErrorMessages;

    facilityClasses = fieldData.facilityClasses;
    facilities: any = null;
    isFacilityAddressError: boolean = false;
    isMailingAddressError: boolean = false;
    disableFacility: boolean = true;
    facility: any = null;
    facilitiesDb: any = null;
    contactsDb: any = null;
    mounted(): void {
        this.initializeComponent(this.name);
        //this.disableFacility = this.$props.isReadOnly || this.$props.isRenewal;
        let siteType = this.$props.form.permitName == "RecyclingFacilityApplication"
            ? "Recycling Facility"
            : this.$props.form.permitName == "CCDDApplication"
                ? "CCDD"
                : "Unknown";  
        api.getFacilities(siteType)
            .then(res => {
                this.facilitiesDb = res;
                this.facilitiesDb = this.facilitiesDb.data;
                this.facilities = this.facilitiesDb.map((f: any) => f.facilityName);
                this.facilities = this.facilities.map(Function.prototype.call, String.prototype.trim);
            });

        if (this.$props.form.facilityOwners.length === 0) {
            this.addOwner();
        }

        if (this.$props.form.facilityOperators.length === 0) {
            this.addOperator();
        }

        this.$watch("form.facilityNameSelect", (n, o) => {
            if (this.facilitiesDb == null) {
                return;
            }
            var facilityAddress = null;

            var facilityId = this.$props.form.facilityNameSelect.substring(this.$props.form.facilityNameSelect.lastIndexOf('-') + 2);
            this.facility = this.facilitiesDb.find((f: any) => f.facilityId == facilityId);

            if (this.facility == null) {
                facilityAddress = fieldData.emptyAddress[0];
                this.$props.form.facilityOwners = [];
                this.$props.form.facilityOperators = [];
            } else {
                facilityAddress = this.facility.address;
                this.$props.form.facilityName = this.facility.facilityName;
                var vm = this;
                this.$props.form.facilityOwners = [];
                this.$props.form.facilityOperators = [];
                api.getContacts(this.facility.objectId.toString())
                    .then(res => {
                        this.contactsDb = res;
                        this.contactsDb = this.contactsDb.data;

                        this.contactsDb.forEach(function (contact: any) {
                            contact.disable = true;
                            if (contact.contactType == "Owner") {
                                vm.$props.form.facilityOwners.push(contact);
                            } else if (contact.contactType == "Operator") {
                                vm.$props.form.facilityOperators.push(contact);
                            }
                        });
                        if (this.$props.form.facilityOwners.length == 0) {
                            this.addOwner();
                        }
                        if (this.$props.form.facilityOperators.length == 0) {
                            this.addOperator();
                        }
                    });
            }
            if (facilityAddress != null) {
                this.$props.form.facilityAddress = facilityAddress;
                if (facilityAddress != fieldData.emptyAddress[0]) {
                    if (this.facility != null) {
                        this.$props.form.facilityId = this.facility.objectId;
                        this.$props.form.facilityRefId = this.facility.facilityId;
                        var currClass = this.facilityClasses.find((x: any) => x.name == this.facility.facilityClass)!;
                        if (currClass != null) {
                            this.$props.form.facilityClass = this.facility.facilityClass;
                            if (this.$props.form.permitName == "RecyclingFacilityApplication") {
                                this.updateClassFee();
                            }
                            $('.classDropdown option[value=' + currClass.name + ']').attr('selected', 'selected');
                        } else {
                            this.$props.form.facilityClass = null;
                            if (this.$props.form.permitName == "RecyclingFacilityApplication") {
                                this.updateClassFee();
                            }
                        }
                    }
                }
            } else {
                this.$props.form.facilityAddress = fieldData.emptyAddress[0];
                this.$props.form.facilityOwners = [];
                this.$props.form.facilityOperators = [];
            }
        }, { immediate: true });

    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    get hasFacilityClass(): boolean {
        return fieldData.getFee(this.$props.vueStates.formName).name === "Facility Class Fee";
    }

    get isFacilityClassError(): boolean {
        return this.hasFacilityClass && func.isNullOrEmpty(this.$props.form.facilityClass);
    }

    updateClassFee(): void {
        let item = this.facilityClasses.find((fc, ix, arr) => fc.name === this.$props.form.facilityClass);
        if (item !== undefined) {
            this.$props.form.fees[0].amount = item.value;
        } else {
            this.$props.form.fees[0].amount = 0;
        }
    }

    get canAddOwner(): boolean {
        return this.$props.form.facilityOwners.length < 5;
    }

    addOwner(): void {
        if (this.canAddOwner) {
            this.$props.form.facilityOwners.push(func.getEmptyContact());
        }
    }

    removeOwner(ownerId: string): void {
        let owners = this.$props.form.facilityOwners as IContactVueModel[];
        let index = owners.map((item) => item.id).indexOf(ownerId);
        owners.splice(index, 1);
    }

    get canAddOperator(): boolean {
        return this.$props.form.facilityOperators.length < 5;
    }

    addOperator(): void {
        if (this.canAddOperator) {
            this.$props.form.facilityOperators.push(func.getEmptyContact());
        }
    }

    removeOperator(operatorId: string): void {
        let operators = this.$props.form.facilityOperators as IContactVueModel[];
        let index = operators.map((item) => item.id).indexOf(operatorId);
        operators.splice(index, 1);
    }

    //Does the work of hasErrors, but checks on every input change and validates owners and operators
    checkStatus(): void {
        let owners = this.$props.form.facilityOwners as [{ hasErrors: boolean }];
        let operators = this.$props.form.facilityOperators as [{ hasErrors: boolean }];
        let res = this.isFacilityNameError || this.isFacilityAddressError || this.hasMailingAddressError || owners.some(owner => owner.hasErrors == true) || operators.some(operator => operator.hasErrors == true);
        this.$props.vueStates.views[this.index].error = res;
    }

    get isFacilityNameError(): boolean {
        return func.isNullOrEmpty(this.$props.form.facilityName);
    }

    get hasOwnerErrors(): boolean {
        let owners = this.$props.form.facilityOwners as [{ hasErrors: boolean }];
        return owners.some(owner => owner.hasErrors);
    }

    get hasOperatorErrors(): boolean {
        let operators = this.$props.form.facilityOperators as [{ hasErrors: boolean }];
        return operators.some(operator => operator.hasErrors);
    }

    get hasMailingAddressError(): boolean {
        if (this.$props.form.hasMailingAddress) {
            return this.isMailingAddressError;
        }
        return false;
    }

    get hasErrors(): boolean {
        return this.isFacilityNameError || this.isFacilityAddressError || this.hasMailingAddressError || this.hasOwnerErrors || this.hasOperatorErrors;
    }
}
